<template>
  <v-row>
    <v-col md="12">
      <h3>Auditoria Medica</h3>
    </v-col>
    <v-col md="12">
      <h4>{{ Cantidades }}</h4>
    </v-col>
    <v-col md="12">
      <lista
        v-if="!selected"
        :items="listaxarea"
        tomar
        v-model="selected"
      ></lista>
    </v-col>
    <v-col md="12" v-if="!selected">
      <v-pagination
        v-model="pagina"
        :length="Paginas"
        :total-visible="15"
      ></v-pagination>
    </v-col>
    <v-col md="12" v-if="selected">
      <Modificar
        auditoria
        :idsolic="selected.id_solic"
        @guardado="guardado()"
      ></Modificar>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modificar from '@/components/Practica/Modificar'
import usuario from '@/components/Usuarios/TraerNombre'
import lista from '@/components/Practica/Lista'
import LUM from '@/lib/LUM'
export default {
  components: {
    Modificar,
    usuario,
    lista
  },
  props: ['id_afiliado'],
  created() {
    if (this.sinmanejador[2]) {
      this.setManejador(2)
      this.$msjpusher.$on('practica-tomada', this.practicatomada)
      this.$msjpusher.$on('practica-guardada', this.practicaguardada)
    }
  },
  destroyed() {
    // this.$msjpusher.$on("practica-tomada", this.practicatomada);
    // this.$msjpusher.$on("practica-guardada", this.practicaguardada);

    this.$msjpusher.$on('practica-tomada', (datos) => {})
    this.$msjpusher.$on('practica-guardada', (datos) => {})
  },
  data() {
    return {
      pagina: 1,
      selected: undefined,
      headers: [
        { text: 'Nro.Solic', value: 'id_solic' },
        { text: 'fecha', value: 'fecha' },
        { text: 'Afiliado', value: 'Beneficiarios.apellido_y_nombre' },
        { text: 'Practica', value: 'baso001.des_nom' },
        { text: 'Estado', value: 'Estados.descripcion_estado' },
        { text: 'Efector', value: 'Efector.nombreefector' },
        { text: 'TomadaPor', value: 'TomadaPor' }
      ]
    }
  },
  computed: {
    ...mapState('comun', ['sinmanejador', 'bandejaactual']),
    ...mapState('autorizaciones', ['ListaPorArea', 'Paginas', 'Filtros', 'Cantidades']),
    ...mapState('areas', { listaareas: 'Lista' }),
    listaxarea() {
      let ret = []
      if (this.ListaPorArea) {
        let lst = [...this.ListaPorArea]
        //lst.sort(LUM.dynamicSort("-internadoen"));
        // lst.sort(LUM.dynamicSort("estado"));
        ret = lst
      }
      return ret
    }
  },
  methods: {
    ...mapActions('autorizaciones', ['traerPorAreaPaginado', 'resetFiltros']),
    ...mapActions('comun', ['setBandeja', 'setManejador']),
    practicatomada(datos) {
      let autoriz = this.ListaPorArea.find((x) => x.id_solic === datos.id_solic)
      if (autoriz) {
        autoriz.TomadaPor = datos.id_user
      }
    },
    practicaguardada(datos) {
      if (datos.id_area == 2 && this.bandejaactual == 2) {
        this.traerPorAreaPaginado({ id_area: 2, pagina: this.pagina })
      }
      // else {
      //   let autoriz = this.ListaPorArea.find(
      //     (x) => x.id_solic === datos.id_solic
      //   );
      //   if (autoriz) {
      //     this.traerPorAreaPaginado(2);
      //   }
      // }
    },
    guardado() {
      this.selected = undefined
      //this.traerPorAreaPaginado(2);
    },
    getColor(id_estado) {
      let ret = 'lime lighten-4'
      switch (id_estado) {
        case 1:
          ret = 'red'
          break
        case 2:
          ret = 'green'
          break
        case 3:
          ret = 'blue'
          break
        case 4:
          ret = 'black'
          break
        case 5:
          ret = 'white'
          break
        default:
          break
      }
      return ret
    }
  },
  watch: {
    pagina() {
      this.traerPorAreaPaginado({ id_area: 2, pagina: this.pagina })
    },
    Filtros() {
      this.pagina = 1
      this.traerPorAreaPaginado({ id_area: 2, pagina: 1 })
    }
  },
  mounted() {
    this.setBandeja(2)
    this.traerPorAreaPaginado({ id_area: 2, pagina: this.pagina })
    this.resetFiltros()
  }
}
</script>
